import * as R from 'ramda'
import store from '@/store'
import i18n from '@/plugins/i18n'

export const toRegistration = () => {
  const mainUrl = store.getters.getConfig.domainWorld
  return mainUrl + '/{locale}/registration/{referral}'
    .replace('{locale}', i18n.locale)
    .replace('{referral}', store.getters.getProfile.inviteCode)
}

export const formatCoin4 = (val) => {
  return +val.toFixed(4)
}

/**
 *
 */
export const findUpAttr = (el, attrName) => {
  while (el.parentNode) {
    el = el.parentNode
    const attr = R.path(['attributes', attrName], el)
    if (attr) return attr.value
  }
  return null
}
